// extracted by mini-css-extract-plugin
module.exports = {"row":"Legende_row__8XoAV","icone":"Legende_icone__1i9Ix"};